import { PartsCategory } from './parts.category';

export class UniversalPartsCategory extends PartsCategory {
    CatalogPartsCategories: PartsCategory[];
}
